import React, { useEffect, useState, useMemo, useRef } from "react";
import { useVirtualizer } from "@tanstack/react-virtual";
import Cookies from "universal-cookie";

const OmGrupo = () => {
  const parentRef = useRef();

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(new Set());
  const [active, setActive] = useState(null);
  const [groupDesc, setGroupDesc] = useState("");
  const [loading, setLoading] = useState(true);
  const cookie = new Cookies();
  const tipoUsuario = cookie.get("tipo_Usuario");
  const institucionId = cookie.get("institucionid");

  const API_GET =
    tipoUsuario == 2
      ? `https://suadesarrollo.azurewebsites.net/api/ObtenerOportunidadMejoraAgrupacion/0/${institucionId}`
      : "https://suadesarrollo.azurewebsites.net/api/ObtenerOportunidadMejora/0/a";

  const API_POST = "https://suadesarrollo.azurewebsites.net/api/CrearGrupoOm";

  useEffect(() => {
    fetch(API_GET)
      .then((r) => r.json())
      .then((json) => setData(Array.isArray(json) ? json : []))
      .finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    const s = search.toLowerCase();
    return data.filter(
      (i) =>
        i.descripcion?.toLowerCase().includes(s) ||
        i.origen?.toLowerCase().includes(s) ||
        i.estadoOportunidad?.toLowerCase().includes(s),
    );
  }, [data, search]);

  const rowVirtualizer = useVirtualizer({
    count: filtered.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 95,
  });

  const toggleSelect = (id) => {
    setSelected((prev) => {
      const s = new Set(prev);
      s.has(id) ? s.delete(id) : s.add(id);
      return s;
    });
  };

  const getEstadoColor = (estado) => {
    switch (estado) {
      case "CERRADO":
        return { bg: "#fee2e2", color: "#b91c1c" };
      case "PARCIAL":
        return { bg: "#fef9c3", color: "#92400e" };
      case "ABIERTO":
        return { bg: "#dcfce7", color: "#15803d" };
      default:
        return { bg: "#e5e7eb", color: "#374151" };
    }
  };

  const handleCreate = async () => {
    if (!groupDesc.trim()) {
      alert("Debes ingresar una descripción del grupo");
      return;
    }

    const payload = {
      Descripcion: groupDesc,
      omHijasIds: Array.from(selected),
    };

    try {
      const res = await fetch(API_POST, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error();

      alert("Grupo creado 🚀");
      setSelected(new Set());
      setGroupDesc("");
    } catch {
      alert("Error al crear grupo");
    }
  };

  if (loading)
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <div style={{ fontSize: 18 }}>Cargando OMs...</div>
      </div>
    );

  return (
    <div style={{ display: "flex", height: "100vh", background: "#f4f6f8" }}>
      {/* 🧾 LISTA */}
      <div style={{ flex: 1, padding: 24 }}>
        {/* HEADER CARD */}
        <div
          style={{
            background: "#fff",
            padding: 20,
            borderRadius: 14,
            boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
            marginBottom: 16,
          }}
        >
          <h2 style={{ margin: 0 }}>Agrupación de Oportunidades</h2>
          <p style={{ margin: "4px 0 12px", color: "#6b7280" }}>
            Selecciona múltiples OMs y agrúpalas
          </p>

          <input
            placeholder="Descripción del grupo"
            value={groupDesc}
            onChange={(e) => setGroupDesc(e.target.value)}
            style={inputStyle}
          />

          <div style={{ display: "flex", gap: 12, marginTop: 12 }}>
            <input
              placeholder="Buscar por descripción, origen o estado..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={inputStyle}
            />

            <button
              onClick={handleCreate}
              disabled={selected.size === 0}
              style={{
                ...buttonStyle,
                opacity: selected.size === 0 ? 0.6 : 1,
              }}
            >
              Crear grupo ({selected.size})
            </button>
          </div>
        </div>

        {/* LISTA */}
        <div
          ref={parentRef}
          style={{
            height: 620,
            overflow: "auto",
            borderRadius: 14,
            background: "#fff",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
          }}
        >
          <div
            style={{
              height: rowVirtualizer.getTotalSize(),
              position: "relative",
            }}
          >
            {rowVirtualizer.getVirtualItems().map((virtualRow) => {
              const item = filtered[virtualRow.index];
              if (!item) return null;

              const isSelected = selected.has(item.id);
              const estadoStyle = getEstadoColor(item.estadoOportunidad);

              return (
                <div
                  key={item.id}
                  onClick={() => setActive(item)}
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: virtualRow.size,
                    transform: `translateY(${virtualRow.start}px)`,
                    padding: 14,
                    borderBottom: "1px solid #f1f5f9",
                    background: isSelected ? "#e0f2fe" : "#fff",
                    transition: "all 0.2s",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#f9fafb")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = isSelected
                      ? "#e0f2fe"
                      : "#fff")
                  }
                >
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => toggleSelect(item.id)}
                      onClick={(e) => e.stopPropagation()}
                      style={{ marginTop: 4 }}
                    />

                    <div style={{ marginLeft: 12, flex: 1 }}>
                      <div style={titleStyle} title={item.descripcion}>
                        {item.descripcion}
                      </div>

                      <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                        <Badge text={item.origen} />

                        <Badge
                          text={item.estadoOportunidad}
                          bg={estadoStyle.bg}
                          color={estadoStyle.color}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* PANEL DERECHO */}
      <div
        style={{
          width: 360,
          background: "#ffffff",
          borderLeft: "1px solid #e5e7eb",
          padding: 24,
        }}
      >
        {active ? (
          <>
            <h3>Detalle</h3>

            <div style={{ marginBottom: 12 }}>
              <strong>Origen</strong>
              <div>{active.origen}</div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <strong>Estado</strong>
              <div>{active.estadoOportunidad}</div>
            </div>

            <div>
              <strong>Descripción</strong>
              <div style={{ marginTop: 6, whiteSpace: "pre-wrap" }}>
                {active.descripcion}
              </div>
            </div>
          </>
        ) : (
          <div style={{ color: "#9ca3af" }}>
            Selecciona una OM para ver detalles
          </div>
        )}
      </div>
    </div>
  );
};

/* 🎨 COMPONENTES UI */

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 10,
  border: "1px solid #d1d5db",
  outline: "none",
  fontSize: 14,
};

const buttonStyle = {
  background: "#2563eb",
  color: "#fff",
  border: "none",
  padding: "10px 18px",
  borderRadius: 10,
  cursor: "pointer",
  fontWeight: 500,
};

const titleStyle = {
  fontWeight: 500,
  fontSize: 14,
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
};

const Badge = ({ text, bg = "#e0f2fe", color = "#0369a1" }) => (
  <span
    style={{
      background: bg,
      color,
      padding: "4px 10px",
      borderRadius: 999,
      fontSize: 11,
      fontWeight: 500,
    }}
  >
    {text}
  </span>
);

export default OmGrupo;
